import { getBaseUrl, slugify, toSnakeCase } from '../constant';
import './LocationsLayout.scss'

export default function LocationsLayout({ regions, viewAll,link }) {
  const usRegion = regions.find(r => r.title === "United States");
  const otherRegions = regions.filter(r => r.title !== "United States");
  console.log('link', link)
console.log('usRegion', usRegion)


  return (
    <div className='locations-container'>
    <div className="locations-layout">
      {/* United States - 50% width */}
      <div className='first-section'>
        <a href={usRegion.href} className="menu-title">{usRegion.title}</a>
        <div className="us-column">
          {usRegion.states.map((state, i) => (
            <a href={`${state.href}`} key={i} className="menu-link">{state.text}</a>
          ))}
        </div>
       
      </div>

      {/* Other regions - 50% width */}
      <div className="others-column">
        {otherRegions.map((region, idx) => (
          <div key={idx} className="menu-column">
            <a href={region.href} className="menu-title">{region.title}</a>
            <ul className="menu-list">
              {(region.countries || []).map((country, i) => (
                <li key={i}><a href={`${country.href}`} className="menu-link" >{country.text}</a></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
     {viewAll && (
          <a href={viewAll.href} className="view-all">{viewAll.text}</a>
        )}
    </div>
  );
}
